import TeamsListPageContainer from './containers/TeamsListPageContainer'

export default TeamsListPageContainer
